import React from 'react';
import { AlertTriangle, UserCheck, UserX, X } from 'lucide-react';
import { persianDisplayText } from '@/lib/persianUi';

export default function UserStatusModal({ isOpen, user, onClose, onConfirm }) {
  if (!isOpen || !user) return null;
  const isDeactivating = user.is_active;

  return (
    <div className="admin-modal-backdrop" onClick={onClose}>
      <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
        <div className="admin-modal-header">
          <div className="admin-modal-header-left">
            <div className={`admin-modal-icon ${isDeactivating ? 'danger' : 'success'}`}>
              {isDeactivating ? <AlertTriangle size={20} /> : <UserCheck size={20} />}
            </div>
            <h3 className="admin-modal-title">
              {isDeactivating ? 'تغییر وضعیت به غیرفعال' : 'فعال‌سازی حساب کاربر'}
            </h3>
          </div>
          <button onClick={onClose} className="admin-modal-close">
            <X size={20} />
          </button>
        </div>

        <div className="admin-modal-body">
          <p>
            آیا از تغییر وضعیت حساب کاربر{' '}
            <strong>
              {user.first_name
                ? `${persianDisplayText(user.first_name, 'کاربر')} ${persianDisplayText(user.last_name, '')}`
                : 'کاربر'}
            </strong>{' '}
            اطمینان دارید؟
          </p>
          {isDeactivating ? (
            <div className="admin-info-box warning">
              با غیرفعال‌سازی این کاربر، دسترسی وی به سامانه و ثبت سفارش جدید به‌صورت کامل مسدود خواهد شد.
            </div>
          ) : (
            <div className="admin-info-box info">
              پس از فعال‌سازی، کاربر مجدداً قادر به ورود و استفاده از تمامی قابلیت‌های سامانه خواهد بود.
            </div>
          )}
        </div>

        <div className="admin-modal-footer">
          <button onClick={onClose} className="btn btn-ghost">
            انصراف
          </button>
          <button
            onClick={() => onConfirm(!user.is_active)}
            className={isDeactivating ? 'btn btn-danger' : 'btn btn-primary'}
          >
            {isDeactivating ? (
              <>
                <UserX size={16} />
                <span>تایید و غیرفعال‌سازی</span>
              </>
            ) : (
              <>
                <UserCheck size={16} />
                <span>تایید و فعال‌سازی</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
